import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppointmentService } from '../../services/appointment.service';
import { DownloadSectionComponent } from '../../components/download-section/download-section.component';

@Component({
  selector: 'app-appointment-reminder',
  templateUrl: './appointment-reminder.component.html',
  styleUrls: ['./appointment-reminder.component.css'],
  standalone: true,
  imports: [CommonModule, DownloadSectionComponent]
})
export class AppointmentReminderComponent implements OnInit {
  appointmentReminderContent: any;

  constructor(private appointmentService: AppointmentService) { }

  ngOnInit(): void {
    this.appointmentService.getAppointmentReminderContent().subscribe(data => {
      this.appointmentReminderContent = data[0];
    });
  }
}
